/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ number: NonNullable<unknown> }} Number_Of_LeftInputs */

const en_number_of_left = /** @type {(inputs: Number_Of_LeftInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.number} left`)
};

const ar_number_of_left = /** @type {(inputs: Number_Of_LeftInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.number} متبقي`)
};

const de_number_of_left = /** @type {(inputs: Number_Of_LeftInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.number} übrig`)
};

const es_number_of_left = /** @type {(inputs: Number_Of_LeftInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Quedan ${i?.number}`)
};

const fr_number_of_left = /** @type {(inputs: Number_Of_LeftInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.number} restants`)
};

const it_number_of_left = /** @type {(inputs: Number_Of_LeftInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.number} rimanenti`)
};

const ja_number_of_left = /** @type {(inputs: Number_Of_LeftInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`残り${i?.number}個`)
};

const ko_number_of_left = /** @type {(inputs: Number_Of_LeftInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.number}개 남음`)
};

const pt_br_number_of_left = /** @type {(inputs: Number_Of_LeftInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.number} restantes`)
};

const ru_number_of_left = /** @type {(inputs: Number_Of_LeftInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Осталось ${i?.number}`)
};

const th_number_of_left = /** @type {(inputs: Number_Of_LeftInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`เหลือ ${i?.number}`)
};

const tr_number_of_left = /** @type {(inputs: Number_Of_LeftInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.number} kaldı`)
};

const zh_cn_number_of_left = /** @type {(inputs: Number_Of_LeftInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`剩下 ${i?.number} 个`)
};

const zh_tw_number_of_left = /** @type {(inputs: Number_Of_LeftInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`剩下 ${i?.number} 個`)
};

/**
* | output |
* | --- |
* | "{number} left" |
*
* @param {Number_Of_LeftInputs} inputs
* @param {{ locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }} options
* @returns {LocalizedString}
*/
export const number_of_left = /** @type {((inputs: Number_Of_LeftInputs, options?: { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Number_Of_LeftInputs, { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_number_of_left(inputs)
	if (locale === "ar") return ar_number_of_left(inputs)
	if (locale === "de") return de_number_of_left(inputs)
	if (locale === "es") return es_number_of_left(inputs)
	if (locale === "fr") return fr_number_of_left(inputs)
	if (locale === "it") return it_number_of_left(inputs)
	if (locale === "ja") return ja_number_of_left(inputs)
	if (locale === "ko") return ko_number_of_left(inputs)
	if (locale === "pt_br") return pt_br_number_of_left(inputs)
	if (locale === "ru") return ru_number_of_left(inputs)
	if (locale === "th") return th_number_of_left(inputs)
	if (locale === "tr") return tr_number_of_left(inputs)
	if (locale === "zh_cn") return zh_cn_number_of_left(inputs)
	return zh_tw_number_of_left(inputs)
});